import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { altoonaIaConfig } from "./data";

export default function AltoonaIaPage() {
  return <CityPageTemplate config={altoonaIaConfig} />;
}